"use client";

import type { LexicalEditor } from "lexical";
import { $getNodeByKey, $isParagraphNode } from "lexical";
import { $isListItemNode } from "@lexical/list";

import { slashMenuCancelledUntilNextSlashRef } from "../menus/slashMenuCancelledRef";

/**
 * 手柄锚定的块若为「空段落」或列表项内首个空段落，返回该段落节点 key；否则 null。
 * 须在 `editor.getEditorState().read` 外调用（内部会 read）。
 */
export function readEmptyParagraphKeyForBlockHandle(editor: LexicalEditor, blockKey: string | null): string | null {
  if (!blockKey) return null;
  let out: string | null = null;
  editor.getEditorState().read(() => {
    const n = $getNodeByKey(blockKey);
    if (!n) return;
    if ($isParagraphNode(n)) {
      if (n.getTextContent().trim() === "") {
        out = slashMenuCancelledUntilNextSlashRef.current ? null : n.getKey();
      }
      return;
    }
    if ($isListItemNode(n)) {
      for (const c of n.getChildren()) {
        if ($isParagraphNode(c)) {
          if (c.getTextContent().trim() === "") {
            out = slashMenuCancelledUntilNextSlashRef.current ? null : c.getKey();
          }
          return;
        }
      }
    }
  });
  return out;
}
